import {
  DESTINATION_TYPES,
  DESTINATION_TYPES_V2,
} from '../../../pages/MultiCheckout/constants/destinationType';
import { CART_TRACKER_TYPE_FOR_V1_AND_V2 } from '../../constants/tracker';
import './../services.tracker';
import { isObject } from 'lodash-es';

app.service('multiCheckoutService', [
  'mainConfig',
  '$http',
  '$filter',
  'slFeatureService',
  'trackerService',
  function (mainConfig, $http, $filter, slFeatureService, trackerService) {
    let store = {
      destinations: null,
    };

    const HTTP_HEADERS = {
      'X-Requested-With': 'XMLHttpRequest',
      cacheKey: mainConfig.currentPath,
    };

    const isEnabled = () => {
      return slFeatureService.hasFeature('multi_checkout');
    };

    const getMultiCheckoutForm = () =>
      $http({
        method: 'GET',
        url: '/cart/multi_cart_form',
        headers: HTTP_HEADERS,
      })
        .then(function (response) {
          return response.data;
        })
        .catch(() => {
          throw new Error(
            $filter('translate')('order_comment_and_message.general_error'),
          );
        });

    const updateMultiCheckoutForm = (payload) =>
      $http({
        method: 'PUT',
        url: '/cart/multi_cart_form',
        headers: HTTP_HEADERS,
        data: payload,
      })
        .then(function (response) {
          return response.data;
        })
        .catch(function () {
          throw new Error(
            $filter('translate')('order_comment_and_message.general_error'),
          );
        });

    const validateDelivery = () =>
      $http({
        method: 'POST',
        url: '/cart/validate_delivery',
        headers: HTTP_HEADERS,
        data: {},
      }).catch((errorResponse) => {
        const error = isObject(errorResponse?.data)
          ? { data: errorResponse?.data }
          : {
              data: {
                all: {
                  message: $filter('translate')(
                    'order_comment_and_message.general_error',
                  ),
                },
              },
            };
        throw error;
      });

    const getCartDestination = () =>
      $http({
        method: 'GET',
        url: '/cart/multi_cart_destination',
        headers: HTTP_HEADERS,
      })
        .then(function (response) {
          return response.data;
        })
        .catch(() => {
          throw new Error(
            $filter('translate')('order_comment_and_message.general_error'),
          );
        });

    const updateCartDestination = (payload) =>
      $http({
        method: 'PUT',
        url: '/cart/multi_cart_destination',
        headers: HTTP_HEADERS,
        data: payload,
      })
        .then(function (response) {
          return response.data;
        })
        .catch(function () {
          throw new Error(
            $filter('translate')('order_comment_and_message.general_error'),
          );
        });

    const saveSessionData = (payload) =>
      $http.post('/api/orders/session_data', payload);

    /**
     * Transform destination type from v1 to v2
     * @param {string} destinationType - The destination object
     * @param {string} [deliveryOptionId] - The delivery option id
     * @returns {string} The transformed destination type
     */
    const transformDestinationTypeFromV1ToV2 = (
      destinationType,
      deliveryOptionId,
    ) => {
      if (destinationType === DESTINATION_TYPES.STORE_PICK_UP) {
        return `${DESTINATION_TYPES.STORE_PICK_UP}_${deliveryOptionId}`;
      }

      // because `save_address` is the same as `address` in checkout revamp
      // align tracker event for `save_address` and `address`
      if (destinationType === DESTINATION_TYPES.SAVE_ADDRESS) {
        return DESTINATION_TYPES_V2.ADDRESS;
      }

      // because `skip_destination` is replaced by `no_destination_display` in checkout revamp
      // use `no_destination_display` for tracking skip_destination
      if (destinationType === DESTINATION_TYPES.SKIP_DESTINATION) {
        return DESTINATION_TYPES_V2.NO_DESTINATION_DISPLAY;
      }

      return destinationType;
    };

    const trackFillRecipientData = (destinationTypeV1, deliveryOptionId) => {
      if (!isEnabled()) return;

      const totalDestinationType = store.destinations.map((destination) =>
        transformDestinationTypeFromV1ToV2(
          destination.blockType,
          destination.option._id,
        ),
      );

      trackerService.track({
        type: CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_RECIPIENT_ADDRESS_TYPE,
        data: {
          event_category: 'Cart',
          total_destination_type: totalDestinationType,
          current_destination_type: transformDestinationTypeFromV1ToV2(
            destinationTypeV1,
            deliveryOptionId,
          ),
        },
      });
    };

    const setDestinations = (destinations) => {
      store.destinations = destinations;
    };

    return {
      isEnabled,
      isToggleOn: () => {
        return (
          isEnabled() &&
          !!mainConfig.merchantData.checkout_setting?.multi_checkout?.enabled
        );
      },
      getMultiCheckoutForm,
      updateMultiCheckoutForm,
      validateDelivery,
      getCartDestination,
      updateCartDestination,
      saveSessionData,
      trackFillRecipientData,
      setDestinations,
    };
  },
]);
